<template>
  <div class="mx-1 my-1">
    <v-chip v-if="smd.includes(value)" color="amber lighten-4">{{ value}}</v-chip>
    <v-chip v-else-if="tht.includes(value)" color="light-blue lighten-4">{{ value}}</v-chip>
    <v-chip v-else-if="montage.includes(value)" color="lime lighten-4">{{ value}}</v-chip>
    <v-chip v-else color="blue-grey lighten-4">{{ value}}</v-chip>
  </div>
</template>

<script>

export default {
  name: 'BatchRunTaskName',
  inheritAttrs: false,
  props: {
    value: {default: null},
  },

  components: {},

  computed: {
  },

  methods: {
  },

  async mounted() {
  },

  data() {
    return {
      smd: ['SMD-VORB', 'SMD', 'SMD-QS', ],
      tht: ['THT-VORB', 'THT', 'THT-QS', ],
      montage: ['MONTAGE-VORB', 'MONTAGE', 'MONTAGE-QS', ],
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n src="@/components/PBatchRun/locales.json">
</i18n>
